export default function camelToHyphen(camelString) {
  return camelString.replace(/[A-Z]/g, string => `-${string.toLowerCase()}`).toLowerCase();
}
